module.exports = __webpack_public_path__ + "img/t2-c30.ac5dd41c.png";